import useCustomTranslation from '@/hooks/useCustomTranslation'
import { useAppSelector } from '@/redux/store'
import { selectConfigRound } from '@/redux/store/modules/rocketTshow'
import { Flex, Stack } from '@chakra-ui/react'
import { f } from 'fintech-number'
import React from 'react'
import { NotoSansFontFamily } from '@/utils/rocketFontFamily.ts'
import RocketText from '@components/rocket/RocketText.tsx'

export default function RoundConfig() {
  const roundConfig = useAppSelector(selectConfigRound)
  const { t } = useCustomTranslation()

  return (
    <Flex
      width="100%"
      gap={1}
      justifyContent="space-between"
      {...NotoSansFontFamily.normal}
      color="#9cb4d9"
      fontSize="12px"
      lineHeight="1"
      fontStyle="italic"
      padding="0 16px 22px"
    >
      <Stack gap={1.5}>
        <RocketText>
          {t('betLimit')}:
        </RocketText>
        <RocketText>
          {f(+roundConfig?.minBetAmount, {
            decimal: 2,
          })}
          {' '}-{' '}
          {f(+roundConfig?.maxBetAmount, {
            decimal: 2,
          })}
        </RocketText>
      </Stack>
      <Stack gap={1.5}>
        <RocketText>
          {t('maxRewardAltitude')}:
        </RocketText>
        <RocketText>
          {f(+roundConfig?.maxMultiple, {
            decimal: 2,
          })}
          x
        </RocketText>
      </Stack>
      <Stack gap={1.5}>
        <RocketText>
          {t('maxProfit')}:
        </RocketText>
        <RocketText>
          {f(+roundConfig?.maxBetAmount, {
            decimal: 2,
          })}
        </RocketText>
      </Stack>
    </Flex>
  )
}
